"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Android_1 = __importDefault(require("../Icons/Android"));
var Apple_1 = __importDefault(require("../Icons/Apple"));
var Facebook_1 = __importDefault(require("../Icons/Facebook"));
var Instagram_1 = __importDefault(require("../Icons/Instagram"));
var Twitter_1 = __importDefault(require("../Icons/Twitter"));
var config = {
    columns: [
        {
            items: [
                {
                    linkProps: {
                        href: '//nl.veepee.be/registration/aboutuslogged'
                    },
                    text: 'Wie zijn we'
                },
                {
                    linkProps: {
                        href: '//nl.veepee.be/postsales/contactselector'
                    },
                    text: 'Help & Contact'
                }
            ],
            title: 'Over Veepee'
        },
        {
            items: [
                {
                    linkProps: {
                        href: '//nl.veepee.be/northdocs/benl/tos_BENL.pdf',
                        target: '_blank'
                    },
                    text: 'Algemene voorwaarden'
                },
                {
                    linkProps: {
                        href: '//nl.veepee.be/northdocs/benl/PP_Veepee_BENL.pdf',
                        target: '_blank'
                    },
                    text: 'Privacy & cookie beleid'
                }
            ],
            title: 'Juridische informatie'
        },
        {
            items: [
                {
                    linkProps: {
                        href: '//careers.veepee.com/en/home-page-en',
                        target: '_blank'
                    },
                    text: 'Veepee'
                },
                {
                    linkProps: {
                        href: '//careers.veepee.com/vptech-2/',
                        target: '_blank'
                    },
                    text: 'vpTech'
                }
            ],
            title: 'Jobs'
        },
        {
            items: [],
            title: ''
        }
    ],
    country: 'BE',
    flag: 'BE-NL',
    header: {
        apps: {
            items: [
                {
                    icon: Apple_1.default,
                    label: 'iOS',
                    linkProps: {
                        href: '//apps.apple.com/be/app/veepee-by-vente-privee/id906681058',
                        target: '_blank'
                    }
                },
                {
                    icon: Android_1.default,
                    label: 'Android',
                    linkProps: {
                        href: '//play.google.com/store/apps/details?id=com.venteprivee',
                        target: '_blank'
                    }
                }
            ],
            title: 'Apps'
        },
        social: [
            {
                icon: Instagram_1.default,
                label: 'Instagram',
                linkProps: {
                    href: '//www.instagram.com/veepee_benelux/',
                    target: '_blank'
                }
            },
            {
                icon: Facebook_1.default,
                label: 'Facebook',
                linkProps: {
                    href: '//www.facebook.com/Veepee.Benelux/',
                    target: '_blank'
                }
            },
            {
                icon: Twitter_1.default,
                label: 'Twitter',
                linkProps: {
                    href: '//twitter.com/Veepee_Benelux/',
                    target: '_blank'
                }
            }
        ]
    },
    lang: 'nl',
    logoSubtitle: 'VP, grandes marques à prix discount'
};
exports.default = config;
